import { render, staticRenderFns } from "./single.vue?vue&type=template&id=1024b444&scoped=true"
import script from "./single.vue?vue&type=script&lang=js"
export * from "./single.vue?vue&type=script&lang=js"
import style1 from "./single.vue?vue&type=style&index=1&id=1024b444&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1024b444",
  null
  
)

export default component.exports